import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { DialogCheckboxData } from 'src/app/modules/dialogs/dialogs.model';
import { AppButtonSize, AppButtonType } from 'src/app/shared/shared.model';

@Component({
  selector: 'app-dialog-checkbox',
  templateUrl: './app-dialog-checkbox.component.html',
  styleUrls: ['./app-dialog-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppDialogCheckboxComponent {
  public btnTypes = AppButtonType;
  public btnSizes = AppButtonSize;
  public checkboxControl: FormControl<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogCheckboxData,
    private dialogRef: MatDialogRef<AppDialogCheckboxComponent>,
    private translocoService: TranslocoService,
  ) {
    this.checkboxControl = new FormControl<boolean>(data.checkboxModel, {
      nonNullable: true,
    });
  }

  public getLabel(item: string): string {
    return this.translocoService.translate(`buttons.${item}`);
  }

  public close(action: string): void {
    this.dialogRef.close({
      action,
      checkboxModel: this.checkboxControl.value,
    });
  }
}
